import kidsRoom from '@/assets/img/users-cases/kids-room.webp';
import kidsRoomHow from '@/assets/img/users-cases/kids-room-how.webp';
import kidsRoomResult from '@/assets/img/users-cases/kids-room-result.webp';

export default {
  slug: 'kids-room',
  order: 22,
  title: 'Kids Room 3D Interior',
  subtitle: 'Family-friendly renderings with soft 3D visuals',
  tags: ['Kidsroomlayouts', 'InteriorDesign'],

  images: {
    hero: kidsRoom,
    aboutTop: kidsRoomHow,
    aboutBottom: kidsRoomResult,
  },

  howText:
    'We worked out 2D and 3D kids room layouts and interior design solutions that clearly show zoning for sleep, play, and study.',

  resultText:
    'These visuals help marketing teams highlight the functional value of family units.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
